import script from "./MakeDeliveryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MakeDeliveryModal.vue?vue&type=script&setup=true&lang=js"

import "./MakeDeliveryModal.vue?vue&type=style&index=0&id=ff76e6ea&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff76e6ea"]])

export default __exports__